import RecoverAccountByTextPage from './RecoverAccountByTextPage';

export default RecoverAccountByTextPage;


// WEBPACK FOOTER //
// ./src/components/pages/RecoverAccountByTextPage/index.js